module.exports = __webpack_public_path__ + "img/password.7c685e6a.svg";